import { useState, useEffect } from "react";
import { Navigate, Outlet, Link, useLocation } from "react-router-dom";
import { Spinner } from "@/components/ui/spinner";
import { useAuth, getClaim } from "@/hooks/use-auth";

import img from "@/assets/signin.png";

export function LoginLayout() {
    const { user, loading } = useAuth();
    const location = useLocation();

    const [claimState, setClaimState] = useState({
        loading: true,
        claim: null,
    });

    useEffect(() => {
        let cancelled = false;

        const resolveClaim = async () => {
            setClaimState({ loading: true, claim: null });

            if (!user || !user.emailVerified) {
                if (!cancelled) {
                    setClaimState({ loading: false, claim: null });
                }
                return;
            }

            const claim = await getClaim(user);

            if (!cancelled) {
                setClaimState({ loading: false, claim });
            }
        };

        resolveClaim();

        return () => {
            cancelled = true;
        };
    }, [user]);

    if (loading || claimState.loading) {
        return (
            <div className="flex h-screen w-screen items-center justify-center">
                <Spinner size="xl" />
            </div>
        );
    }

    if (
        user?.emailVerified &&
        (claimState.claim === "patient" || claimState.claim === "clinician")
    ) {
        if (location.state?.from === "booking" && location.state?.booking) {
            return (
                <Navigate
                    to="/clinicians/book"
                    replace
                    state={location.state.booking}
                />
            );
        }

        return (
            <Navigate
                to={
                    claimState.claim === "patient"
                        ? "/patient/manage"
                        : "/clinician"
                }
                replace
            />
        );
    }

    return (
        <main className="flex h-dvh w-dvw flex-col before:absolute before:h-full before:w-full before:bg-beige/40">
            <div className="relative z-1 flex flex-1 px-4">
                <div className="m-auto w-lg max-w-dvw">
                    <div className="rounded-3xl bg-beige/75 shadow-[0_5px_15px_rgba(0,0,0,0.1)] backdrop-blur-md">
                        <div className="flex items-center justify-center p-6 md:p-12">
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
            <div className="relative z-1 mt-4 mb-16 flex items-center justify-center">
                <Link to="/">
                    <img src="/logo-darkgreen.svg" width="280" height="55" />
                </Link>
            </div>
            <img
                src={img}
                className="absolute -z-1 h-full w-full object-cover object-[30%_20%]"
            />
        </main>
    );
}
